export default "__VITE_ASSET__BK74zKYK__"